import React from "react";
import Marquee from "react-fast-marquee";

export default function Ticker() {
  const word = "PROFESSIONAL TREE SERVICES YOU CAN TRUST";
  return (
    <div data-testid="marquee" className="py-8 overflow-hidden" style={{ background: "var(--pine)" }}>
      <Marquee speed={40} gradient={false}>
        {[...Array(4)].map((_, i) => (
          <span key={i} className="font-display font-extrabold uppercase text-4xl md:text-6xl text-outline mx-8 select-none">
            {word} <span className="mx-8" style={{ color: "var(--brass)" }}>✳</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
